import * as React from "react";
import ImageTextCta, { ImageTextCtaProps } from "../image-text-cta/image-text-cta";

export interface AuthorTeaserProps extends ImageTextCtaProps {}

const AuthorTeaser = (props: AuthorTeaserProps) => {
    return (
        <ImageTextCta
            className="author-teaser"
            {...props}
            showCtaAsLink
            styleWithProductTheme
            fadeOverflowingRichText
        />
    );
};

export default AuthorTeaser;
